export default [
  {
    path: '/contacts/list',
    name: 'contacts-list',
    component: () => import('@/views/contact/contacts-list/ContactsList.vue'),
  },
  {
    path: '/contacts/detail/:id',
    name: 'contacts-detail',
    component: () => import('@/views/contact/contacts-detail/ContactsDetail.vue'),
  },
  {
    path: '/contacts/edit/:id',
    name: 'contacts-edit',
    component: () => import('@/views/contact/contacts-edit/ContactEdit.vue'),
  },
]
